import { Button } from '@/components/form/baseInputs/Button';
import { Stars01Icon } from '@/components/icons/Stars01Icon';
import { COLORS } from '@/styles/tokens/colors';

export interface ToggleChatButtonProps {
  isChatOpen: boolean;
  onOpenChat: () => void;
  onCloseChat: () => void;
}

export function ToggleChatButton({
  isChatOpen,
  onOpenChat,
  onCloseChat,
}: ToggleChatButtonProps) {
  return (
    <Button
      size="sm"
      variant="secondary"
      startIcon={Stars01Icon}
      onClick={isChatOpen ? onCloseChat : onOpenChat}
      iconProps={{ color: COLORS.TEAL['600'], size: 16 }}
    >
      Chat
    </Button>
  );
}
